<script lang="ts">
    import type {Session} from './types';
    import {sessionService} from './services';

    export let session: Session;
</script>

<span>
	{#await sessionService.getBestUsername(session.id)}
		{session.username}
	{:then operatorName}
		{operatorName}
	{/await}
</span>
